<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('New Repairable Defect') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/repairable-defects">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading.create"></loading>
        <form @submit.prevent="saveDefect">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Defect information') }}
              </h3>
              <p class="form-description-text">{{ $t('Defect information and customization') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="form-label" for="device_id">{{ $t('Device') }}</label>
                  <div class="pt-1">
                    <select class="form-input bg-white" id="device_id" required v-model="defect.device_id">
                      <option :value="null" disabled>
                        {{ $t('Select an option') }}
                      </option>
                      <option :key="index" :value="device.id" v-for="(device, index) in deviceList">
                        {{ device.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="title">{{ $t('Defect Title') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Defect Title')" class="form-input" id="title" required v-model="defect.title" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="time">{{ $t('Repair required time') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Repair required time')" class="form-input" id="time" required v-model="defect.required_time" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="cost">{{ $t('Cost') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Cost')" class="form-input" id="cost" required v-model="defect.cost" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="price">{{ $t('Price') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Price')" class="form-input" id="price" required v-model="defect.price" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <span class="inline-flex">
              <router-link class="btn btn-secondary shadow-sm rounded-md mr-4" to="/admin/repairable-defects">
                {{ $t('Close') }}
              </router-link>
              <button class="btn btn-green shadow-sm rounded-md" type="submit">
                {{ $t('Save defect') }}
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading.import"></loading>
        <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
          <div class="md:col-span-1">
            <h3 class="form-description-head">
              {{ $t('Batch imports') }}
            </h3>
            <p class="form-description-text">
              {{ $t('Upload file for batch entries') }}.
              <br />
              {{ $t('A file should be CSV with format') }}.
              <br />
              {{ $t('A file must have only columns with title of') }}
              <span class="text-red-600">"title","price","cost","time"</span>
            </p>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="device">{{ $t('Device') }}</label>
                <div class="pt-1">
                  <select class="form-input bg-white" id="device" required multiple v-model="devices">
                    <option :value="null" disabled>
                      {{ $t('Select a device or multiple devices to link defects') }}
                    </option>
                    <option :key="index" :value="device.id" v-for="(device, index) in deviceList">
                      {{ device.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="name">{{ $t('Excel CSV file') }}</label>
                <div class="pt-1">
                  <input
                    @change="onChangeFileUpload"
                    class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    ref="file"
                    required
                    type="file"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="inline-flex">
            <button :disabled="!file" @click="importMultipleDefects" class="btn btn-app shadow-sm rounded-md" type="submit">
              {{ $t('Upload') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'edit',
  metaInfo() {
    return {
      title: this.$i18n.t('Create defect'),
    };
  },
  data() {
    return {
      loading: {
        create: false,
        import: false,
      },
      deviceList: [],
      defect: {
        name: null,
        price: null,
        cost: null,
        device_id: null,
        required_time: null,
      },
      devices: [],
      file: null,
    };
  },
  mounted() {
    this.getDevices();
  },
  methods: {
    importMultipleDefects() {
      this.loading.import = true;
      const formData = new FormData();
      formData.append('file', this.file);
      if (this.devices.length) {
        formData.append('devices', this.devices);
      }
      axios
        .post(route('multiple-defects.import'), formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          this.loading.import = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/repairable-defects');
        })
        .catch(() => {
          this.loading.import = false;
        });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    saveDefect() {
      this.loading.create = true;
      axios
        .post(route('defects.store'), this.defect)
        .then((response) => {
          this.loading.create = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push(`/admin/repairable-defects/${response.data.defect.id}/edit`);
        })
        .catch(() => {
          this.loading.create = false;
        });
    },
    getDevices() {
      this.loading.create = true;
      axios
        .get(route('device.list'))
        .then((response) => {
          this.deviceList = response.data;
          this.loading.create = false;
        })
        .catch(() => {
          this.loading.create = false;
        });
    },
  },
};
</script>
